import DecryptCardDetaiTemplate from "../../../templates/users/decryptCard";

const DecryptCardDetailsScreen = () => {
  return <DecryptCardDetaiTemplate />;
};

export default DecryptCardDetailsScreen;
